import { render, staticRenderFns } from "./ReportsComponent.vue?vue&type=template&id=7f0a37f5"
import script from "./ReportsComponent.vue?vue&type=script&lang=js"
export * from "./ReportsComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jquispe/itcm-inca-platform-app/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7f0a37f5')) {
      api.createRecord('7f0a37f5', component.options)
    } else {
      api.reload('7f0a37f5', component.options)
    }
    module.hot.accept("./ReportsComponent.vue?vue&type=template&id=7f0a37f5", function () {
      api.rerender('7f0a37f5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/apps/asset-governance/pages/ReportsComponent.vue"
export default component.exports